import { NavLink } from "react-router-dom";

import styles from "./Sidebar.module.css";
import { SidebarTree } from "./SidebarTree";

import type { NavItem as NavItemType } from "@/types/navigation";

interface SidebarProps {
  /** Tool entries (Approvals, Settings…) already permission-filtered by AppShell. */
  tools: readonly NavItemType[];
  activePath: string;
}

/**
 * The dark-chrome navigation rail (prototype design): the OPERATIONS MANUAL
 * section tree (SidebarTree — plain navigation for everyone, plus in-place
 * reorder/access management for cms.manage holders), and the TOOLS slot
 * pinned to the bottom. Restricted sections the caller can't see never
 * arrive from the nav API. The brand lives in the header above.
 */
export function Sidebar({ tools, activePath }: SidebarProps) {
  return (
    <aside className={styles.sidebar} aria-label="Primary">
      <nav className={styles.nav} aria-label="OpsHub Sections">
        <div className={styles.navLabel}>OpsHub Sections</div>
        <SidebarTree />
      </nav>

      {tools.length > 0 && (
        <div className={styles.tools}>
          <div className={styles.navLabel}>Tools</div>
          <ul>
            {tools.map((item) => (
              <li key={item.id}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    isActive || activePath.startsWith(`${item.path}/`)
                      ? `${styles.toolLink} ${styles.toolActive}`
                      : styles.toolLink
                  }
                >
                  <item.icon aria-hidden />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </aside>
  );
}
